import { KatapultEditorTemplate } from './katapult-editor-template';
import { html } from '@polymer/polymer';
import '../katapult-switcher/katapult-switcher.js';
import { PortalStyle } from './katapult-model-editor-style.js';

class KatapultCustomLineStylesEditor extends KatapultEditorTemplate {
  static get template() {
    return html`
      ${PortalStyle} ${super.style}
      <style></style>

      <template is="dom-repeat" items="[[steps]]" as="step">
        <katapult-editor-step
          step$="[[step.id]]"
          creating-item="[[creatingItem]]"
          active="[[step.active]]"
          index="[[step.index]]"
          current-index="[[currentIndex]]"
          title="[[step.title]]"
        >
          <template is="dom-if" if="[[equal(step.id, 'path')]]" restamp>
            <iron-icon icon="help" slot="header">
              <katapult-tooltip style="max-width:300px;" position="right">
                To build a custom line style, add line and space components with lengths relative to each other. Each custom line style
                should start with a line component and end with a space component to properly build the repeating pattern. Keep in mind
                that, in general, lines smaller than 1px and spaces smaller than 5px will not display well.
              </katapult-tooltip>
            </iron-icon>
            <div flex column grow slot="body" style="max-width:700px;">
              <svg viewBox="0 0 [[lineLength]] 2" style="width:100%; height:5px; margin-bottom:24px;" xmlns="http://www.w3.org/2000/svg">
                <line
                  x1="0"
                  y1="1"
                  x2$="[[lineLength]]"
                  y2="1"
                  stroke="black"
                  stroke-dasharray$="[[_itemData.dasharray]]"
                  stroke-linecap="round"
                />
              </svg>
              <paper-table rounded outline grow overflow-hidden>
                <paper-table-scroll data-path="_itemData.pieces" on-sort-changed="orderedItemsArraySortChanged">
                  <!-- Header -->
                  <paper-row grey short slot="before">
                    <paper-cell icon>
                      <material-icon icon="swap_vert"></material-icon>
                    </paper-cell>
                    <paper-cell input>Type</paper-cell>
                    <paper-cell input>Length</paper-cell>
                    <paper-cell icon></paper-cell>
                  </paper-row>
                  <!-- Body -->
                  <template is="dom-repeat" items="[[getOrderedItemsArray(_itemData.pieces.*)]]" mutable-data>
                    <paper-row slot="sortable" divider>
                      <paper-cell icon>[[add(index, 1)]]</paper-cell>
                      <paper-cell input>
                        <katapult-switcher items="[[lineTypes]]" value="[[lineOrSpace(index)]]" disabled></katapult-switcher>
                      </paper-cell>
                      <paper-cell input>
                        <paper-input
                          label="Length"
                          value="[[item.length]]"
                          type="number"
                          min="[[getMin(index)]]"
                          step="1"
                          data-path="_itemData.pieces.$(model.item.$key).length"
                          underline
                          no-label-float
                          on-value-changed="updateProperty"
                        ></paper-input>
                      </paper-cell>
                      <paper-cell icon-button>
                        <katapult-button
                          iconOnly
                          noBorder
                          icon="delete"
                          data-path="_itemData.pieces.$(model.item.$key)"
                          data-value="$null"
                          on-click="updateProperty"
                        ></katapult-button>
                      </paper-cell>
                    </paper-row>
                  </template>
                  <!-- Add Button -->
                  <paper-row class="addButton" ripple light-grey short slot="after" data-path="_itemData.pieces" on-click="addOrderedItem">
                    <paper-cell>
                      <material-icon icon="playlist_add"></material-icon>
                      <div>Add Component</div>
                    </paper-cell>
                  </paper-row>
                </paper-table-scroll>
              </paper-table>
            </div>
          </template>
        </katapult-editor-step>
      </template>
      ${super.createItemContainer}
    `;
  }

  static get properties() {
    return {
      lineLength: {
        type: Number,
        value: 0
      },
      lineTypes: {
        type: Array,
        value: () => ['Line', 'Space']
      }
    };
  }

  static get observers() {
    return ['pieceChanged(_itemData.pieces.*)'];
  }

  ready() {
    super.ready();

    this.keyMatchLabel = true;

    // An ordered list of all possible steps.
    this.setSteps([
      {
        id: 'path',
        title: 'Line Components',
        trigger: () => this.get('_itemData.pieces') != null
      }
    ]);
  }
  lineOrSpace(index) {
    return index % 2 == 0 ? 'Line' : 'Space';
  }
  getMin(index) {
    return this.lineOrSpace(index) == 'Line' ? 1 : 5;
  }
  addPiece(e) {
    // e.detail = {type:}
  }
  // pieceChanged() {
  //   let validPieces = Object.values(this._itemData?.pieces ?? {}).filter(x => x?.length && x?.type).sort((a, b) => a.order - b.order);
  //   let path = validPieces.map(x => `${(x.type == 'Space' ? 'm':'l')} 0 -${x.length}`).join(', ')
  //   if (path.startsWith('l')) {
  //     path = 'M 0 0, ' + path;
  //   }
  //   else if (path.startsWith('m')) {
  //     path = 'M' + path.slice(1);
  //   }
  //   this.set('_itemData.path', path);
  //   this.set('_itemData.width', validPieces.reduce((acc, a) => acc + Number(a.length), 0));
  // }

  pieceChanged() {
    let validPieces = Object.values(this._itemData?.pieces ?? {})
      .filter((x) => x?.length)
      .sort((a, b) => a.order - b.order)
      .map((x) => Number(x.length));
    this.set('_itemData.dasharray', validPieces.join(' '));
    this.set(
      'lineLength',
      validPieces.reduce((a, b) => a + b, 0)
    );
  }
}

customElements.define('katapult-custom-line-styles-editor', KatapultCustomLineStylesEditor);
